// extracted by mini-css-extract-plugin
module.exports = {"main_div":"sharedButton_main_div__xcq0T","shared_buttons":"sharedButton_shared_buttons__HPkSr"};